"use client";
// РУКА 2. Корзина покупателя — в браузере (переживает перезагрузку), до оформления заказа.
// Храним только что и сколько: товар по id или комплект по slug. Цены не храним — берём актуальные
// при показе корзины (цена из 1С могла поменяться).
import { useSyncExternalStore } from "react";

export type CartLine = { kind: "product"; id: string; qty: number } | { kind: "kit"; slug: string; qty: number };

const KEY = "santex-cart";
const EMPTY: CartLine[] = [];
const listeners = new Set<() => void>();
let cache: CartLine[] | null = null;

function read(): CartLine[] {
  if (cache) return cache;
  try {
    const v = JSON.parse(localStorage.getItem(KEY) ?? "[]");
    cache = Array.isArray(v) ? (v as CartLine[]) : [];
  } catch {
    cache = [];
  }
  return cache;
}

function write(lines: CartLine[]) {
  cache = lines;
  try {
    localStorage.setItem(KEY, JSON.stringify(lines));
  } catch {
    // нет доступа к хранилищу (приватный режим) — корзина живёт до закрытия вкладки
  }
  listeners.forEach((f) => f());
}

const same = (a: CartLine, b: CartLine) =>
  a.kind === b.kind && (a.kind === "product" ? a.id === (b as typeof a).id : a.slug === (b as typeof a).slug);

export function addToCart(line: CartLine) {
  const lines = read();
  const i = lines.findIndex((l) => same(l, line));
  write(i < 0 ? [...lines, line] : lines.map((l, k) => (k === i ? { ...l, qty: l.qty + line.qty } : l)));
}

export function setQty(line: CartLine, qty: number) {
  write(qty <= 0 ? read().filter((l) => !same(l, line)) : read().map((l) => (same(l, line) ? { ...l, qty } : l)));
}

function subscribe(f: () => void) {
  listeners.add(f);
  const onStorage = (e: StorageEvent) => {
    if (e.key === KEY) {
      cache = null; // корзину поменяли в другой вкладке
      f();
    }
  };
  window.addEventListener("storage", onStorage);
  return () => {
    listeners.delete(f);
    window.removeEventListener("storage", onStorage);
  };
}

export function useCart(): CartLine[] {
  return useSyncExternalStore(subscribe, read, () => EMPTY);
}
